import { z } from 'zod';
import { PositionStructureIntentSchema } from './PositionStructureIntent';

/** One authored gesture, one immutable revision; child intents never publish independently. */
export const OrgChartEditBatchIntentSchema = z.object({
  kind: z.literal('edit_batch'),
  intentId: z.string().uuid(),
  mode: z.literal('scenario'),
  expectedGraphVersion: z.number().int().nonnegative(),
  effectiveAt: z.string().datetime(),
  ownerDiagramId: z.string().min(1),
  scenarioId: z.string().uuid().optional(),
  scenarioChangeSetId: z.string().min(1).optional(),
  expectedHeadChangeSetId: z.string().min(1).optional(),
  scenarioName: z.string().trim().min(1).max(120).optional(),
  intents: z.array(PositionStructureIntentSchema).min(1).max(32),
}).strict().superRefine((batch, context) => {
  const ids = new Set([batch.intentId]);
  for (const [index, intent] of batch.intents.entries()) {
    const same = intent.mode === 'scenario'
      && intent.expectedGraphVersion === batch.expectedGraphVersion
      && intent.ownerDiagramId === batch.ownerDiagramId
      && intent.effectiveAt === batch.effectiveAt
      && intent.scenarioId === batch.scenarioId
      && intent.scenarioChangeSetId === batch.scenarioChangeSetId
      && intent.expectedHeadChangeSetId === batch.expectedHeadChangeSetId;
    if (!same || ids.has(intent.intentId)) context.addIssue({
      code: 'custom', path: ['intents', index], message: 'All edits must belong to the same revision with distinct intent identities.',
    });
    ids.add(intent.intentId);
  }
});

export type OrgChartEditBatchIntent = z.infer<typeof OrgChartEditBatchIntentSchema>;
